var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcQuizzesEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B7B7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.322 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C66.895 14.974 51.921 0 33.448 0 14.974 0 0 14.974 0 33.448 0 51.92 14.974 66.895 33.448 66.895c8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.333 90 90 82.333l-25.678-25.73Zm-30.874 0c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.767 30.078)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.628,
    cy: 4.392,
    rx: 1.628,
    ry: 1.647
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.085,
    width: 1.085,
    height: 3.843,
    rx: 0.543
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.632 18a1.647 1.647 0 1 1 0 3.294h-.524v1.357c5.272 1.136 9.225 5.873 9.225 11.545C45.333 40.716 40.11 46 33.667 46 27.223 46 22 40.715 22 34.196c0-5.865 4.227-10.73 9.767-11.648v-1.254h-.523a1.647 1.647 0 0 1 0-3.294h5.388Zm-2.965 7.686c-4.646 0-8.411 3.81-8.411 8.51 0 4.7 3.765 8.51 8.41 8.51 4.646 0 8.412-3.81 8.412-8.51 0-4.7-3.766-8.51-8.411-8.51Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuizzesEmpty);
export default __webpack_public_path__ + "static/media/ic-quizzes-empty.cda91fa812d730b26d16a064e6d363df.svg";
export { ForwardRef as ReactComponent };